import { init } from "@nosto/preact"
import { Serp, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { unbindOriginalSearch } from "./helpers"

import "./styles/index.css"

unbindOriginalSearch('#Search-In-Modal');

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    inputCssSelector: "#Search-In-Modal",
    contentCssSelector: "#MainContent",
    formCssSelector: '.search-modal__form',
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    serpPath: '/search',
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId", "url", "categories",
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value",
                "priceCurrencyCode", "onDiscount",
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", "categories",
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value",
                "priceCurrencyCode", "onDiscount",
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    // categoryComponent: Category,
    // categoryCssSelector: '#MainContent',
    // fallback: true,
    // categoryQuery() {
    //     return {
    //         name: 'serp',
    //         products: {
    //             categoryId: this.categoryId(),
    //             // categoryPath: this.categoryPath(),
    //             size: defaultConfig.serpSize,
    //             from: 0,
    //             fields: [
    //                 "productId", "url", "categories",
    //                 "name", "tags1",
    //                 "imageUrl", "alternateImageUrls",
    //                 "brand", "availability",
    //                 "price", "listPrice",
    //                 "customFields.key", "customFields.value",
    //                 "skus.name", "skus.price", "skus.listPrice",
    //                 "skus.availability", "skus.id", "skus.imageUrl",
    //                 "skus.customFields.key", "skus.customFields.value",
    //                 "priceCurrencyCode", "onDiscount"
    //             ],
    //         }
    //     }
    // },
})
.then(() => {
    const closeMobileSearch = () => {
        const closeMobileMenuBtn = document.querySelector('#Details-menu-drawer-container > summary');
        if(closeMobileMenuBtn) {
            closeMobileMenuBtn.click();
            closeMobileMenuBtn.blur();
        }
    }

    document.querySelectorAll('.js-header-drawer #Search-In-Modal')?.forEach(inputEl => {
        inputEl.addEventListener('keydown', (e) => {
            if(e.key === 'Enter') {
                closeMobileSearch();
            }
        })
    })
    
})